import React from 'react';
import { Outlet } from 'react-router-dom';

const CustomerDashboardLayout: React.FC = () => <Outlet />;

export default CustomerDashboardLayout;
